import { render, staticRenderFns } from "./Page_Payment.vue?vue&type=template&id=16450369&scoped=true&"
import script from "./Page_Payment.vue?vue&type=script&lang=js&"
export * from "./Page_Payment.vue?vue&type=script&lang=js&"
import style0 from "./Page_Payment.vue?vue&type=style&index=0&id=16450369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16450369",
  null
  
)

export default component.exports